export default function escogeArticulo(array, articuloID) {
  const salida = array.filter((a) => a.articuloID === articuloID);
  return salida.length > 0 ? salida[0] : {};
}
